import CancelIcon from "@mui/icons-material/Cancel";
import { Components, Theme } from "@mui/material";

export const MuiChip: Components<Theme>["MuiChip"] = {
  defaultProps: {
    deleteIcon: <CancelIcon />,
    variant: "outlined",
  },
  styleOverrides: {
    label: ({ theme }) => ({
      padding: theme.spacing(0, 1),
    }),
  },
};
